import { render } from "./EvmCoinETHDepositManual.vue?vue&type=template&id=3e5d4874"
import script from "./EvmCoinETHDepositManual.vue?vue&type=script&lang=js"
export * from "./EvmCoinETHDepositManual.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__